import React from "react";

const mediaFrameClass =
  "st-testi-media-frame relative w-full overflow-hidden border aspect-[4/3] sm:aspect-[16/10] md:aspect-[16/9] lg:aspect-auto lg:h-full lg:min-h-full";

const mediaImageClass =
  "h-full w-full object-cover [object-position:var(--st-img-pos-mobile)] md:[object-position:var(--st-img-pos-tablet)] lg:[object-position:var(--st-img-pos-desktop)]";

const getDefaultPanelClass = (expanded) =>
  expanded
    ? "hidden lg:absolute lg:inset-0 lg:block lg:translate-x-4 lg:opacity-0 lg:pointer-events-none lg:transition-all lg:duration-300 lg:ease-out"
    : "block lg:absolute lg:inset-0 lg:translate-x-0 lg:opacity-100 lg:transition-all lg:duration-300 lg:ease-out";

const getExpandedPanelClass = (expanded) =>
  expanded
    ? "block lg:absolute lg:inset-0 lg:translate-x-0 lg:opacity-100 lg:transition-all lg:duration-300 lg:ease-out"
    : "hidden lg:absolute lg:inset-0 lg:block lg:-translate-x-4 lg:opacity-0 lg:pointer-events-none lg:transition-all lg:duration-300 lg:ease-out";

const mediaPositionStyle = (data) => ({
  "--st-img-pos-mobile": data.imagePositionMobile || data.imagePosition || "center center",
  "--st-img-pos-tablet": data.imagePositionTablet || data.imagePosition || "center center",
  "--st-img-pos-desktop": data.imagePosition || "center center",
});

const TestimoniCard = ({ data, expanded, onToggle }) => {
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onToggle();
    }
  };

  return (
    <article
      role="button"
      tabIndex={0}
      onClick={onToggle}
      onKeyDown={handleKeyDown}
      className="st-testi-panel st-testi-card-elevated st-focus-ring relative cursor-pointer overflow-hidden border p-4 sm:p-5 lg:h-[370px] lg:min-h-[420px] lg:p-4"
    >
      <div className="relative h-full">
        <div className={getDefaultPanelClass(expanded)}>
          <div className="grid gap-4 lg:h-full lg:grid-cols-[1fr_1.02fr] lg:gap-6">
            <div className="st-font-body st-testi-ink flex h-full flex-col lg:pl-5 lg:pr-3 lg:pt-3 xl:pl-8">
              <h3 className="st-font-display st-testi-ink-strong text-[48px] leading-[0.95] sm:text-[56px] lg:leading-[1.02]">
                <span className="italic">Kak</span> <span className="font-bold">{data.name}</span>
              </h3>
              <p className="st-testi-ink-muted mt-2 text-[14px] font-semibold tracking-[0.3em] lg:mt-3">{data.city}</p>

              <div className="st-testi-divider mt-3 border-t pt-3 lg:mt-5 lg:pt-4">
                <p className="st-testi-ink text-[14px] font-bold tracking-[0.24em]">SCORE IMPROVEMENT</p>
                <p className="st-testi-score-chip mt-2 inline-flex rounded-[5px] border px-2 py-1 text-[14px] font-semibold lg:mt-3">
                  {data.scoreImprovement}
                </p>
              </div>

              <div className="st-testi-divider mt-3 grid grid-cols-2 gap-4 border-t pt-3 lg:mt-5 lg:gap-7 lg:pt-4">
                <div>
                  <p className="st-testi-ink text-[14px] font-bold tracking-[0.24em]">Jenis Test IELTS</p>
                  <ul className="st-testi-ink mt-2 space-y-1 text-[15px] leading-[1.22] lg:mt-3 lg:space-y-1.5 lg:leading-[1.28]">
                    {data.acceptance.map((item) => (
                      <li key={item}>· {item}</li>
                    ))}
                  </ul>
                </div>

                <div>
                  <p className="st-testi-ink text-[14px] font-bold tracking-[0.24em]">Beasiswa Tujuan</p>
                  <ul className="st-testi-ink mt-2 space-y-1 text-[15px] leading-[1.22] lg:mt-3 lg:space-y-1.5 lg:leading-[1.28]">
                    {data.scholarship.map((item) => (
                      <li key={item}>· {item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className={mediaFrameClass}>
              <img src={data.image} alt={data.name} className={mediaImageClass} style={mediaPositionStyle(data)} loading="lazy" />
              <div className="st-testi-badge absolute right-3 top-3 rounded-full border px-3 py-1.5 text-center text-[12px] font-semibold leading-tight shadow-sm">
                Tap Here
                <br />
                for More
              </div>
            </div>
          </div>
        </div>

        <div className={getExpandedPanelClass(expanded)}>
          <div className="grid gap-4 lg:h-full lg:grid-cols-[1.02fr_1fr] lg:gap-6">
            <div className={mediaFrameClass}>
              <img src={data.image} alt={data.name} className={mediaImageClass} style={mediaPositionStyle(data)} loading="lazy" />
              <div className="st-testi-badge absolute right-3 top-3 rounded-full border px-3 py-1.5 text-center text-[12px] font-semibold leading-tight shadow-sm">
                Tap Here
                <br />
                for More
              </div>
            </div>

            <div className="st-font-body st-testi-ink flex items-center">
              <p className="max-w-[95%] text-[28px] leading-[1.26] sm:text-[30px]">“{data.quote}”</p>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default TestimoniCard;
